/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const PraetoidError = zod.union([
	zod
		.object({
			error: zod.string()
		})
		.describe('Simple error message'),
	zod
		.object({
			errors: zod.record(zod.string(), zod.array(zod.string()))
		})
		.describe('Field validation errors')
]);

export type PraetoidError = zod.input<typeof PraetoidError>;
export type PraetoidErrorOutput = zod.output<typeof PraetoidError>;
